<template>
  <v-container>
    <v-app>
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="lotojr_colorPrimary"
        dark
      >
        <div class="d-flex align-center" style="margin-right: 50px">
          <v-img
            :src="require('../../assets/rsz_logo.png')"
            class="my-3"
            contain
            width="100"
          />
        </div>
      </v-app-bar>
      <v-layout justify-center align-center style="margin-top: 65px">
        <v-card
          class="card-rounded center"
          min-width="350"
          max-width="750"
          outlined
        >
          <v-form @submit.prevent="signup" ref="signupForm">
            <v-card-title class="signup-title">Cadastre-se</v-card-title>
            <v-card-text style="padding-top: 6px">
              <v-row>
                <v-col cols="12" class="signup-form-input">
                  <v-text-field
                    v-model="profile.nome"
                    label="Nome*"
                    :rules="nomeRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="signup-form-input">
                  <v-text-field
                    v-model="profile.email"
                    label="E-mail*"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="signup-form-input">
                  <v-text-field
                    v-model="profile.cpf"
                    label="CPF*"
                    v-mask="'###.###.###-##'"
                    :rules="cpfRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="6"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  class="signup-form-input"
                >
                  <v-text-field
                    v-model="dtAniversario"
                    v-mask="'##/##/####'"
                    label="Data Nascimento"
                    :rules="[validateDtNasc]"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="6"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  class="signup-form-input"
                >
                  <v-text-field
                    v-model="profile.telefone"
                    label="Telefone"
                    :rules="phoneRules"
                    required
                    v-mask="['(##) ####-####', '(##) #####-####']"
                  ></v-text-field>
                </v-col>

                <!-- <v-col cols="12" class="signup-form-input">
                  <v-col cols="12" align-start>
                    <span>Foto do Documento*</span>
                  </v-col>
                  <v-col cols="12">
                    <div
                      style="min-height: 120px; vertical-align: bottom;"
                      class="drop display-inline align-center"
                      @dragover.prevent
                      @drop="onDrop"
                    >
                      <label for="upload" @click="onChange">
                        <div class="helper"></div>
                        <label v-if="!image" class="btn display-inline">
                          Selecione ou araste um foto do seu documento
                          <input
                            id="upload"
                            type="file"
                            name="image"
                            @change="onChange"
                          />
                        </label>
                        <div
                          class="hidden display-inline align-center"
                          v-else
                          v-bind:class="{ image: true }"
                        >
                          <img
                            :src="image"
                            alt=""
                            class="img"
                            style="max-width: 250px; width:250px; heigth: auto;"
                          />
                          <br />
                        </div>
                      </label>
                    </div>
                    <v-icon v-if="image != ''" @click="removeFile"
                      >delete</v-icon
                    >
                  </v-col>
                </v-col> -->
                <v-col cols="12" class="signup-form-input">
                  <v-text-field
                    label="Senha"
                    id="password"
                    v-model="password"
                    :rules="[passwordLength]"
                    :append-icon="
                      showPassword ? 'visibility' : 'visibility_off'
                    "
                    @click:append="showPassword = !showPassword"
                    :type="showPassword ? 'text' : 'password'"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="signup-form-input">
                  <v-text-field
                    label="Confirme a Senha"
                    id="confirmPassword"
                    v-model="confirmPassword"
                    :rules="[comparePasswords]"
                    :append-icon="
                      showConfirmPassword ? 'visibility' : 'visibility_off'
                    "
                    @click:append="showConfirmPassword = !showConfirmPassword"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="signup-form-input">
                  <v-text-field
                    v-model="profile.cep"
                    label="Cep*"
                    v-mask="'#####-###'"
                    required
                    :rules="requiredRules"
                    @input="check_cep()"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="signup-form-input">
                  <v-text-field
                    v-model="profile.cidade"
                    label="Cidade"
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="signup-form-input">
                  <v-text-field
                    v-model="profile.estado"
                    label="Estado"
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="8" class="signup-form-input">
                  <v-text-field
                    v-model="profile.logradouro"
                    label="Rua"
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="signup-form-input">
                  <v-text-field
                    v-model="profile.bairro"
                    label="Bairro"
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="signup-form-input">
                  <v-text-field
                    v-model="profile.numero"
                    label="Número"
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="signup-form-input">
                  <v-text-field
                    v-model="profile.complemento"
                    label="Complemento"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-layout row wrap>
                    <v-checkbox
                      label=""
                      v-model="privacidadeTermos"
                      :rules="privacidadeTermosRules"
                      class="shrink mr-0 mt-0"
                    >
                    </v-checkbox>
                    <span
                      style="padding-top:5px; position: absolute; left: 35px;"
                      ><span>Declaro que li os </span>
                      <a
                        href="https://lotojr.com.br/termos.html"
                        target="_blank"
                        >Termos de uso</a
                      >
                      <span> e a </span>
                      <a
                        href="https://lotojr.com.br/politica.html"
                        target="_blank"
                        >Politica de Privacidade</a
                      >
                    </span>
                  </v-layout>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                :disabled="loading"
                text
                type="submit"
                >Salvar</v-btn
              >
            </v-card-actions>
          </v-form>
          <app-notification></app-notification>
        </v-card>
      </v-layout>
    </v-app>
  </v-container>
</template>
<script>
import datePicker from "../../components/date-picker";
import Notification from "../../components/Notification";
import { cpf } from "cpf-cnpj-validator";
import axios from "axios";
import { mask } from "vue-the-mask";
import Vue from "vue";
import VuejsDialog from "vuejs-dialog";
import Util from "../../service/util-service";

// include the default style
import "vuejs-dialog/dist/vuejs-dialog.min.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

export default {
  directives: { mask },
  components: {
    "date-picker": datePicker,
    "app-notification": Notification,
  },
  data() {
    return {
      profile: {},
      nomeRules: null,
      emailRules: null,
      cpfRules: null,
      phoneRules: null,
      privacidadeTermosRules: null,
      privacidadeTermos: false,
      dtpData: 0,
      password: null,
      confirmPassword: null,
      urlIndicacao: null,
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      requiredRules: null,
      dtAniversario: "",
      //image: "",
    };
  },
  created() {
    this.urlIndicacao = this.$route.query.h;
    this.createRules();
    this.profile = {};
  },
  watch: {
    "profile.aniversario"(v) {
      console.log(v);
    },
  },
  computed: {
    comparePasswords() {
      if (this.password !== this.confirmPassword) {
        return "As senhas devem ser iguais";
      }
      return;
    },
    passwordLength() {
      if (this.password !== null && this.password.length < 6) {
        return "A senha deve conter ao menos 6 caracteres!";
      }
      return;
    },
    validateDtNasc() {
      if (!this.dtAniversario) {
        return "Data de nascimento é obrigatório";
      } else if (!Util.isValidDate(this.dtAniversario)) {
        return "Data inválida";
      } else {
        let dtAtual = new Date();
        const [day, month, year] = this.dtAniversario.split("/");
        if (dtAtual.getFullYear() - 18 < year) {
          return "Você deve ser maior de idade!";
        } else if (dtAtual.getFullYear() - 18 > year) {
          return true;
        } else {
          if (dtAtual.getMonth() + 1 < month) {
            return "Você deve ser maior de idade!";
          } else if (dtAtual.getMonth() + 1 > month) {
            return true;
          } else {
            if (dtAtual.getDate() < day) {
              return "Você deve ser maior de idade!";
            }
            return true;
          }
        }
      }
    },
  },
  methods: {
    // rua bairro cep complemento cidade estado numero
    check_cep() {
      console.log("INPUT");
      if (this.profile.cep.length == 9) {
        axios
          .get("https://viacep.com.br/ws/" + this.profile.cep + "/json")
          .then((response) => {
            let prof = this.profile;
            console.log(prof);
            if (response.data.erro == true) {
              console.log("CEP não encontrado");
            } else {
              this.profile = {
                cpf: prof.cpf,
                email: prof.email,
                nome: prof.nome,
                telefone: prof.telefone,
                aniversario: prof.aniversario,
                // aniversario: '1967-02-01',
                cep: prof.cep,
                numero: prof.numero,
                logradouro: response.data.logradouro,
                bairro: response.data.bairro,
                complemento: response.data.complemento,
                cidade: response.data.localidade,
                estado: response.data.uf,
              };
              console.log("Ok!");
              console.log(response.data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    createRules() {
      this.requiredRules = [(v) => !!v || "Campo obrigatório"];
      this.nomeRules = [(v) => !!v || "Nome é obrigatório"];
      this.emailRules = [
        (v) => !!v || "E-mail obrigatório",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail inválido!",
      ];
      this.cpfRules = [
        (v) => !!v || "CPF é obrigatório",
        (v) => cpf.isValid(v) || "CPF é inválido",
      ];
      this.phoneRules = [(v) => !!v || "Telefone é obrigatório"];
      this.privacidadeTermosRules = [(v) => !!v || "Campo obrigatório"];
    },
    resetForm() {
      if (this.$refs.signupForm) {
        this.$refs.signupForm.reset();
      }
    },

    validateForm() {
      if (this.$refs.signupForm.validate()) {
        return true;
      }
      return false;
    },
    signup() {
      if (this.validateForm() && !this.loading) {
        this.profile.aniversario = this.dtAniversario;
        this.profile.user = {};
        this.loading = true;
        let e_mail_preenchido = this.profile.email;
        this.profile.email = e_mail_preenchido.toLowerCase();
        this.profile.user.password = this.password;
        this.profile.user.type = "email";
        this.profile.urlIndicacao = this.urlIndicacao;
        this.$store
          .dispatch("signup", this.profile)
          .then((value) => {
            if (value.type == "ok") {
              this.resetForm();
              this.$dialog
                .alert(
                  "Enviamos um link em seu e-mail, clique nele para ativar sua conta! \n Cadastrado com sucesso!"
                )
                .then(function(dialog) {});
              this.$store.dispatch("setNotification", {
                type: "success",
                text:
                  "Usuário criado com sucesso! Ative sua conta clicando no link enviado em seu e-mail.",
              });
            } else {
              this.$store.dispatch("setNotification", {
                type: "error",
                text: value.msg,
              });
              this.loading = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      }
    },
    onDrop: function(e) {
      e.stopPropagation();
      e.preventDefault();
      var files = e.dataTransfer.files;
      //this.createFile(files[0]);
    },
    onChange(e) {
      var files = e.target.files;
      //this.createFile(files[0]);
    },
    createFile(file) {
      if (!file.type.match("image.*")) {
        this.$store.dispatch("setNotification", {
          type: "error",
          text: "Selecione uma imagem",
        });
        return;
      }
      var img = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = function(e) {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeFile() {
      this.image = "";
    },
  },
};
</script>
<style scoped>
.signup-title {
  background-color: #0a1e8c;
  color: white;
}
.signup-form-input {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
* {
  font-family: "Arial";
  font-size: 12px;
}

*,
*:after,
*:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-touch-callout: none;
}

html,
body {
  height: 100%;
  text-align: center;
}

.btn {
  background-color: #d3394c;
  border: 0;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-weight: bold;
  padding: 15px 35px;
  position: relative;
}

.btn:hover {
  background-color: #722040;
}

input[type="file"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.align-center {
  text-align: center;
}

.helper {
  height: 100%;
  display: inline-block;
  vertical-align: middle;
  width: 0;
}

.hidden {
  display: none !important;
}

.hidden.image {
  display: inline-block !important;
}

.display-inline {
  display: inline-block;
  vertical-align: middle;
}

.img {
  border: 1px solid #f6f6f6;
  display: inline-block;
  height: auto;
  max-height: 80%;
  max-width: 80%;
  width: auto;
}

.drop {
  background-color: #f2f2f2;
  border: 4px dashed #ccc;
  background-color: #f6f6f6;
  border-radius: 2px;
  height: 100%;
  max-height: 400px;
  max-width: 600px;
  width: 100%;
}
</style>
